export default {
  parseObject: (obj) => {
    var query = Object.keys(obj)
      .filter(key => obj[key] !== '' && obj[key] !== null)
      .map(key => key + '=' + obj[key])
      .join('&');
    return query.length > 0 ? '?' + query : '';
  }
}


// WEBPACK FOOTER //
// ./src/utils/queryString.js